import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { BundleInterface } from '../../store/callrecorder/bundlesSlice';
import { normalizeCollection as normalizeProductsCollection } from "./productsActions";

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    voip_cert_url: callrecorderUrls.remoteUrl(value.voip_cert_url),
    url: callrecorderUrls.bundlePath(value.id)
  };
}

export const bundlesEntity = new schema.Entity(
  'bundles',
  {},
  {
    processStrategy
  }
);

export const bundleEntity = new schema.Entity(
  'bundle',
  {},
  {
    processStrategy
  }
);

const fetchBundlesCollection = async (url: string, params: object = {}) => {
  const response    = await callrecorderApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      bundles: { [key: string]: BundleInterface };
    }
  >(response.data.bundles, [bundlesEntity]);

  return {
    bundles: normalized.entities?.bundles || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { bundle: BundleInterface; }
  >(response.data.bundle, bundleEntity);
  return normalized.entities;
}

export const fetchBundles = createAsyncThunk(
  `${PREFIX}_bundles/fetchBundles`,
  async (params: object = {}) => fetchBundlesCollection('/onesky/bundles', params)
);

export const fetchBundle = createAsyncThunk(
  `${PREFIX}_bundles/fetchBundle`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/bundles/${id}`);
    return normalizeInstance(response);
  }
);

export const createBundle = createAsyncThunk(
  `${PREFIX}_bundles/createBundle`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.post(`/onesky/bundles`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateBundle = createAsyncThunk(
  `${PREFIX}_bundles/updateBundle`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.patch(`/onesky/bundles/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const updateProducts = createAsyncThunk(
  `${PREFIX}_bundles/updateProducts`,
  async ({ bundleId, data }: { bundleId: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.patch(`/onesky/bundles/${bundleId}/update_products`, data);
      return normalizeProductsCollection(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);


export const destroyBundle = createAsyncThunk(
  `${PREFIX}_bundles/destroyBundle`,
  async (id: number) => {
    const response = await callrecorderApi.delete(`/onesky/bundles/${id}`);
    return response.data;
  }
);
